import Loading from './Loading';

export { Loading };
export default Loading;
